import { DistribId, DistribIdBacktest } from 'utils/types';

export const PERIODICITY_TO_MULTIPLICATOR_AMOUNT_LOOKUP = {
  monthly: 12,
  quarterly: 4,
  biannual: 2,
  annual: 1,
};

export const logColumnsMapping: { [key: string]: { [distribId in DistribId]: boolean } } = {
  startDate: {
    bddf: true,
    bpf: true,
    mfaaas: true,
    mfaaas_v2: true,
    'digital-clubs': true,
    backtest: true,
    mfaaas_advisory: true,
  },
  httpRoute: {
    bddf: true,
    bpf: true,
    mfaaas: true,
    mfaaas_v2: true,
    'digital-clubs': true,
    backtest: true,
    mfaaas_advisory: true,
  },
  httpStatus: {
    bddf: true,
    bpf: true,
    mfaaas: true,
    mfaaas_v2: true,
    'digital-clubs': true,
    backtest: true,
    mfaaas_advisory: true,
  },
  duration: {
    bddf: true,
    bpf: true,
    mfaaas: true,
    mfaaas_v2: true,
    'digital-clubs': true,
    backtest: true,
    mfaaas_advisory: true,
  },
  portfolioAmount: {
    bddf: true,
    bpf: true,
    mfaaas: false,
    mfaaas_v2: false,
    'digital-clubs': true,
    backtest: false,
    mfaaas_advisory: false,
  },
  investmentAmount: {
    bddf: true,
    bpf: true,
    mfaaas: false,
    mfaaas_v2: false,
    'digital-clubs': true,
    backtest: false,
    mfaaas_advisory: false,
  },
  initialVolatility: {
    bddf: false,
    bpf: true,
    mfaaas: true,
    mfaaas_v2: true,
    'digital-clubs': false,
    backtest: false,
    mfaaas_advisory: true,
  },
  initialRISK: {
    bddf: true,
    bpf: false,
    mfaaas: false,
    mfaaas_v2: false,
    'digital-clubs': true,
    backtest: false,
    mfaaas_advisory: false,
  },
  finalVolatility: {
    bddf: false,
    bpf: true,
    mfaaas: true,
    mfaaas_v2: true,
    'digital-clubs': false,
    backtest: false,
    mfaaas_advisory: true,
  },
  finalRISK: {
    bddf: true,
    bpf: false,
    mfaaas: false,
    mfaaas_v2: false,
    'digital-clubs': true,
    backtest: false,
    mfaaas_advisory: false,
  },
  targetVolatility: {
    bddf: false,
    bpf: true,
    mfaaas: true,
    mfaaas_v2: true,
    'digital-clubs': false,
    backtest: false,
    mfaaas_advisory: true,
  },
  targetRISK: {
    bddf: true,
    bpf: false,
    mfaaas: false,
    mfaaas_v2: false,
    'digital-clubs': true,
    backtest: false,
    mfaaas_advisory: false,
  },
  maxVolatility: {
    bddf: false,
    bpf: true,
    mfaaas: true,
    mfaaas_v2: true,
    'digital-clubs': false,
    backtest: false,
    mfaaas_advisory: true,
  },
  transactionId: {
    bddf: false,
    bpf: false,
    mfaaas: false,
    mfaaas_v2: true,
    'digital-clubs': true,
    backtest: true,
    mfaaas_advisory: true,
  },
  adviceId: {
    bddf: false,
    bpf: false,
    mfaaas: false,
    mfaaas_v2: false,
    'digital-clubs': false,
    backtest: false,
    mfaaas_advisory: true,
  },
  sessionId: {
    bddf: false,
    bpf: false,
    mfaaas: false,
    mfaaas_v2: false,
    'digital-clubs': false,
    backtest: false,
    mfaaas_advisory: true,
  },
  sessionStatus: {
    bddf: false,
    bpf: false,
    mfaaas: false,
    mfaaas_v2: false,
    'digital-clubs': false,
    backtest: false,
    mfaaas_advisory: true,
  },
  errorType: {
    bddf: true,
    bpf: true,
    mfaaas: true,
    mfaaas_v2: true,
    'digital-clubs': true,
    backtest: false,
    mfaaas_advisory: true,
  },
} as const;

export const logColumnsMappingBacktest: {
  [key: string]: { [distribId in DistribIdBacktest]: boolean };
} = {
  startDate: {
    bddf: true,
    bnpp_am: true,
    bpf: true,
    'digital-clubs': true,
    hb_fr: true,
    bcef: true,
    bnl: true,
  },
  httpRoute: {
    bddf: true,
    bnpp_am: true,
    bpf: true,
    'digital-clubs': true,
    hb_fr: true,
    bcef: true,
    bnl: true,
  },
  httpStatus: {
    bddf: true,
    bnpp_am: true,
    bpf: true,
    'digital-clubs': true,
    hb_fr: true,
    bcef: true,
    bnl: true,
  },
  duration: {
    bddf: true,
    bnpp_am: true,
    bpf: true,
    'digital-clubs': true,
    hb_fr: true,
    bcef: true,
    bnl: true,
  },
  errorType: {
    bddf: true,
    bnpp_am: true,
    bpf: true,
    'digital-clubs': true,
    hb_fr: true,
    bcef: true,
    bnl: true,
  },
} as const;

export const weightTolerance = 0.01;
